import { BetType } from 'features/coupon/component/CouponPanel/interface';
import { Freebet } from 'features/offers/interface/offers.interface';
import { RewardCard } from 'features/RewardCard';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { defaultBreakpoints } from 'shared/constants/common';
import { Mousewheel, SwiperOptions } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import './styles.scss';

interface FreeBetSelectionProps {
	freeBets: Freebet[];
	activateFreebet: (number: number, stack: number) => void;
	selectedFreeBet: string;
}

const FreeBetSelection = ({ freeBets, selectedFreeBet, activateFreebet }: FreeBetSelectionProps) => {
	const { t } = useTranslation();

	const sortedBets = useMemo(() => {
		return freeBets.reduce((acc, freebet) => {
			if (freebet.offerId === Number(selectedFreeBet)) {
				acc.unshift(freebet);
			} else {
				acc.push(freebet);
			}
			return acc;
		}, [] as typeof freeBets);
	}, [freeBets, selectedFreeBet]);

	const settings: SwiperOptions = {
		slidesPerView: sortedBets.length === 1 ? 1 : 'auto',
		modules: [Mousewheel],
		allowTouchMove: true,
		grabCursor: true,
		loop: false,
		threshold: 5,
		spaceBetween: 8,
		preventClicks: true,
		breakpoints: defaultBreakpoints,
	};

	return (
		<div>
			<div className="font-medium text-primary-500 dark:text-gray-100 text-paragraph-sm mb-2">{t('freebetListTitle')}</div>
			<Swiper {...settings} freeMode={true} navigation={true}>
				{sortedBets.map((item) => (
					<SwiperSlide key={item.offerFreebetId}>
						<RewardCard data={item} type={BetType.Freebet} activateFreebet={activateFreebet} />
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
};

export default FreeBetSelection;
